const { default: axiosIns } = require('@/libs/axios')

const LanguagesService = {
  // GET - LanguageApiController
  async getLanguages() {
    return axiosIns.get('admin/languages')
      .then(response => response.data)
  },
  // POST - LanguageApiController
  async createLanguage(model) {
    return axiosIns.post('admin/languages', model)
      .then(response => response.data)
  },
  async translate(languageId, filter) {
    return axiosIns.post(`admin/languages/${languageId}`, filter)
      .then(response => response.data)
  },
  // PUT - LanguageApiController
  async updateLanguage(model) {
    return axiosIns.put(`admin/languages/${model.id}`, model)
      .then(response => response.data)
  },
  async updateLanguageResource(model) {
    return axiosIns.put(`admin/languages/resources/${model.id}`, model)
      .then(response => response.data)
  },
}

export default LanguagesService
